import { useContext } from 'react';
import { ChartContext } from '../contexts/ChartContext.js';

function useChartContext() {
  const ChartContextValues = useContext(ChartContext);

  if (!ChartContextValues) {
    throw new Error('ChartContext is not defined');
  }

  return ChartContextValues;
}

export { useChartContext };
